/**
 * 使用v-backgroundColor ，设置页面背景颜色
 */
export default {
  inserted(el, binding) {
    document.documentElement.style.backgroundColor = binding.value;
  },
  update(el, binding) {
    document.documentElement.style.backgroundColor = binding.value;
  },
  unbind() {
    document.documentElement.style.backgroundColor = '';
  },
};
